"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _styles = require("@material-ui/core/styles");
var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));
var _i18n = require("../../../../Framework/i18n");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _Link = _interopRequireDefault(require("@material-ui/core/Link"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var styles = function styles() {
  return {
    root: {
      position: 'absolute',
      width: '100%',
      top: 145
    },
    noticeContainer: {
      display: 'flex',
      justifyContent: 'center'
    },
    notice: {
      maxWidth: '90vw',
      backgroundColor: 'rgb(253, 236, 234)',
      color: 'rgb(97, 26, 21)',
      display: 'flex',
      padding: 12,
      zIndex: 2,
      borderRadius: 4
    },
    icon: {
      paddingRight: 8
    },
    tooltip: {
      backgroundColor: 'rgb(253, 236, 234)',
      color: 'rgb(97, 26, 21)'
    }
  };
};
var LicenseNotice = /*#__PURE__*/function (_React$Component) {
  _inherits(LicenseNotice, _React$Component);
  var _super = _createSuper(LicenseNotice);
  function LicenseNotice() {
    _classCallCheck(this, LicenseNotice);
    return _super.apply(this, arguments);
  }
  _createClass(LicenseNotice, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        mobileOffset = _this$props.mobileOffset,
        width = _this$props.width,
        classes = _this$props.classes,
        displayMissingLicenseNotice = _this$props.displayMissingLicenseNotice;
      if (!displayMissingLicenseNotice) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.root,
        style: {
          top: (width === 'xs' || width === 'sm') && mobileOffset ? mobileOffset : 145
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.noticeContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.notice
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, (0, _i18n.t)('licenseNotice.message'), " -", ' ', /*#__PURE__*/_react["default"].createElement(_Link["default"], {
        href: (0, _i18n.t)('licenseNotice.buyLicenseLink'),
        rel: "noopener noreferrer",
        target: "_blank"
      }, (0, _i18n.t)('licenseNotice.linkText'))), /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        classes: {
          tooltip: classes.tooltip
        },
        interactive: true,
        title: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, /*#__PURE__*/_react["default"].createElement(_Link["default"], {
          href: (0, _i18n.t)('licenseNotice.licenseInfoLink'),
          rel: "noopener noreferrer",
          target: "_blank"
        }, (0, _i18n.t)('licenseNotice.viewLicense'))))
      }, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
        className: classes.icon
      })))));
    }
  }]);
  return LicenseNotice;
}(_react["default"].Component);
LicenseNotice.defaultProps = {
  displayMissingLicenseNotice: false
};
var _default = exports["default"] = (0, _withWidth["default"])({
  initialWidth: 'lg'
})((0, _styles.withStyles)(styles, {
  name: 'LicenseNotice'
})(LicenseNotice));